import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const [plan, setPlan] = useState('');
  const [feature, setFeature] = useState('');

  useEffect(() => {
    setPlan(searchParams.get('plan') || '');
    setFeature(searchParams.get('feature') || '');
  }, [searchParams]);

  return (
    <div style={{ 
      maxWidth: '600px', 
      margin: '50px auto', 
      padding: '40px', 
      textAlign: 'center',
      backgroundColor: '#f8f9fa',
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
    }}>
      <div style={{ fontSize: '64px', marginBottom: '20px' }}>✅</div>
      <h1 style={{ color: '#28a745', marginBottom: '20px' }}>Payment Successful!</h1>
      <p style={{ fontSize: '18px', marginBottom: '30px', color: '#6c757d' }}>
        Thank you for your purchase! Your subscription has been activated.
      </p>
      
      <div style={{ 
        backgroundColor: '#e8f5e8', 
        padding: '20px', 
        borderRadius: '8px', 
        marginBottom: '30px',
        border: '1px solid #28a745'
      }}>
        <h3 style={{ marginBottom: '10px', color: '#28a745' }}>Subscription Details</h3>
        <p><strong>Plan:</strong> {plan.toUpperCase()}</p>
        <p><strong>Feature:</strong> {feature}</p>
        <p><strong>Status:</strong> Active</p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ marginBottom: '15px' }}>What's Next?</h3>
        <ul style={{ textAlign: 'left', display: 'inline-block' }}>
          <li>Access premium messaging features</li>
          <li>Join exclusive local meets</li>
          <li>Create and join travel groups</li>
          <li>Unlock advanced personality matching</li>
        </ul>
      </div>

      <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
        <Link to="/feed" style={{
          padding: '12px 24px',
          backgroundColor: '#007bff',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '6px',
          fontWeight: 'bold'
        }}>
          Go to Feed
        </Link>
        <Link to="/messages" style={{
          padding: '12px 24px',
          backgroundColor: '#28a745',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '6px',
          fontWeight: 'bold'
        }}>
          Start Messaging
        </Link>
      </div>
    </div>
  );
} 